module.exports = __webpack_public_path__ + "static/youtubeDetox2-19e524c01640c72fbfd50bb83e68e8b6.gif";